import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

// Define serializable interface for hub connection state
interface HubConnectionState {
  isConnected: boolean;
  connectionId: string | null;
  lastConnectedAt: string | null;
  error: string | null;
}

const initialState: HubConnectionState = {
  isConnected: false,
  connectionId: null,
  lastConnectedAt: null,
  error: null
};

export const HubConnectionObj = createSlice({
  name: 'hubConn',
  initialState,
  extraReducers: (builder) => builder.addCase(logout, () => initialState),
  reducers: { 
    StoreHubConnection: (state, action: PayloadAction<HubConnectionState>) => {         
      return action.payload;
    },
    setConnectionStatus: (state, action: PayloadAction<{ isConnected: boolean; connectionId?: string }>) => {
      state.isConnected = action.payload.isConnected;
      if (action.payload.connectionId) {
        state.connectionId = action.payload.connectionId;
      }
      state.lastConnectedAt = new Date().toISOString();
      state.error = null;
    },
    setConnectionError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnected = false;
    },
    clearConnection: (state) => {
      return initialState;
    }
  },
});

export const { StoreHubConnection, setConnectionStatus, setConnectionError, clearConnection } = HubConnectionObj.actions;
export default HubConnectionObj.reducer;